import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca7a9ee2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-1/1 h-full" }
const _hoisted_2 = { class: "main border border-gray-400" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top_title text-xl text-white" }, "欢迎登录", -1))
const _hoisted_4 = { class: "form_content" }
const _hoisted_5 = { class: "forget-content" }
const _hoisted_6 = { class: "forgetPass font-medium" }
const _hoisted_7 = { class: "login" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_form, {
          model: _ctx.formState,
          rules: _ctx.rules,
          name: "basic",
          onFinish: _ctx.onFinish,
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { name: "userName" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  id: "name",
                  value: _ctx.formState.userName,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.userName) = $event)),
                  placeholder: "请输入账号"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { name: "passWord" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  id: "pass",
                  value: _ctx.formState.passWord,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.passWord) = $event)),
                  type: "password",
                  placeholder: "请输入密码"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", {
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.forgetPass && _ctx.forgetPass(...args)))
                    }, "忘记密码")
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    loading: _ctx.loading,
                    "html-type": "submit"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("登录")
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["model", "rules", "onFinish"])
      ])
    ])
  ]))
}